// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__eCFGy","logo_white":"Logo_logo_white__Mbrvz"};